import { safeAuthFetch } from '../utils/safeFetch';
import { API_BASE_URL } from '../config/api.js';

/** Deterministic chip path — POST a structured {metric, window, grain?, scope?, compare?, preset?, ranking?}.
 *  grain/scope/compare are the Phase 2 (#1660-follow-on) fields threaded through from scope-clarify
 *  chips, template-metric suggestion chips, and table follow-up chips; `preset` (#1694 Task 9) is
 *  threaded the same way from a table's preset chip (a definition-toggle replay, e.g. stuck_learners'
 *  "Include thinner data — 5+ runs"); `ranking` (Phase 3 #1666b Task 6 / human-test round 1) is
 *  threaded identically from a learner-ranking suggestion chip or a table's server-authored
 *  ranking_follow_ups chip — all omitted (not sent as literal `undefined`, JSON.stringify drops
 *  those keys) when the caller doesn't supply them, so every pre-Phase-2/3 {metric, window} call
 *  is byte-identical to before. source/question are passed for nearest-offer acceptance /
 *  preset-chip replay logging only. */
export async function getMetric({ metric, window, grain, scope, compare, preset, ranking, source, question }) {
  const res = await safeAuthFetch(`${API_BASE_URL}/api/analytics/metric`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ metric, window, grain, scope, compare, preset, ranking, ...(source ? { source, question } : {}) }),
  });
  return res.json();
}
